<template>
  <div>
  	<router-view></router-view>
  	<BottomSheet></BottomSheet>
  </div>
</template>

<script>
import DashboardList from './dashboard/List'
import BottomSheet from './BottomSheet'
import EventsEditor from './events/Editor'
import ChannelsEditor from './channels/Editor'
import InstanceEditor from './instances/Editor'

export default {
	routes: [
		{
			path: "",
			redirect: "/dashboard/list"
		},
		{
			path: "list",
			component: DashboardList,
			name: "Dashboard list"
		},
		{
			path: "event_new",
			name: "Dashboard new event",
			components: {
				default: DashboardList,
				bottomEditor: EventsEditor
			},
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        edit: "Dashboard edit event"
      }
		},
		{
			path: "event/:id",
		  name: "Dashboard edit event",
      components: {
        default: DashboardList,
        bottomEditor: EventsEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        new: "Dashboard new event"
      }
		},
		{
			path: "channel/:id",
			name: "Dashboard edit channel",
			components: {
				default: DashboardList,
				bottomEditor: ChannelsEditor
			},
      props: {
        default: false,
        bottomEditor: true
      }
		},
		{
			path: "instance/:id",
			name: "Dashboard edit instance",
			components: {
				default: DashboardList,
				bottomEditor: InstanceEditor
			},
      props: {
        default: false,
        bottomEditor: true
      }
		}
	],
  components: {
  	BottomSheet
  }
}
</script>
